import React, { useState } from 'react';
import { Insight, InsightsSummary } from '../services/insights';

interface InsightsPanelProps {
  insights: InsightsSummary;
  onApplyFilter: (query: string, positionRange?: string) => void;
  onDownloadCSV?: () => void;
  onAddTodo?: (todoData: any) => Promise<any>;
  addedTodos?: Set<string>;
}

// Gradient SVG Icons Component
const GradientIcon: React.FC<{ type: string; size?: string }> = ({ type, size = "w-5 h-5" }) => {
  const iconPaths: { [key: string]: string } = {
    quickWin: "M13 10V3L4 14h7v7l9-11h-7z",
    strikingDistance: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z",
    ctrAnomaly: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z",
    featuredSnippet: "M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z",
    cannibalization: "M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z",
    longTail: "M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z",
    localIntent: "M15 10.5a3 3 0 11-6 0 3 3 0 016 0z M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z",
    page: "M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z",
    warning: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z",
    lightbulb: "M12 18v-5.25m0 0a6.01 6.01 0 001.5-.189m-1.5.189a6.01 6.01 0 01-1.5-.189m3.75 7.478a12.06 12.06 0 01-4.5 0m3.75-7.478a12.06 12.06 0 004.5 0m-3.75 7.478a12.06 12.06 0 010-4.5m-4.5 4.5a12.06 12.06 0 000-4.5m4.5 0a9.75 9.75 0 10-4.5 0M9.75 15.75h4.5m-4.5 0c-.621 0-1.125.504-1.125 1.125M9.75 15.75V12a6 6 0 016-6m4.5 9.75c.621 0 1.125.504 1.125 1.125m-1.125-1.125V12a-6 6 0 00-6-6m-6 9.75h.008v.008H9.75v-.008zM15.75 18v-5.25A2.25 2.25 0 0013.5 10.5h-3A2.25 2.25 0 008.25 12.75V18a2.25 2.25 0 002.25 2.25h3A2.25 2.25 0 0015.75 18z",
    target: "M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
    sparkles: "M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.847a4.5 4.5 0 003.09 3.09L15.75 12l-2.847.813a4.5 4.5 0 00-3.09 3.091zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"
  };

  return (
    <svg className={size} viewBox="0 0 24 24" fill="none">
      <defs>
        <linearGradient id={`gradient-${type}`} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ec4899" />
          <stop offset="100%" stopColor="#8b5cf6" />
        </linearGradient>
      </defs>
      <path
        d={iconPaths[type] || iconPaths.target}
        fill={`url(#gradient-${type})`}
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};

const InsightCard: React.FC<{
  title: string;
  iconType: string;
  insights: Insight[];
  color: string;
  onApplyFilter: (query: string, positionRange?: string) => void;
  onAddTodo?: (todoData: any) => Promise<any>;
  addedTodos?: Set<string>;
}> = ({ title, iconType, insights, color, onApplyFilter, onAddTodo, addedTodos }) => {
  const [addingTodos, setAddingTodos] = useState<Set<string>>(new Set());

  if (insights.length === 0) return null;

  const handleAddTodo = async (insight: Insight) => {
    if (!onAddTodo) return;
    
    const todoKey = `Optimize: ${insight.query}-SEO Opportunities`;
    setAddingTodos(prev => new Set(prev).add(todoKey));

    try {
      await onAddTodo({
        title: `Optimize: ${insight.query}`,
        description: insight.action,
        priority: insight.type === 'quick-win' ? 'high' as const : insight.type === 'striking-distance' ? 'medium' as const : 'low' as const,
        sourcePanel: 'SEO Opportunities'
      });
    } catch (error) {
      console.error('Failed to add todo:', error);
    } finally {
      setAddingTodos(prev => {
        const newSet = new Set(prev);
        newSet.delete(todoKey);
        return newSet;
      });
    }
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-semibold text-gray-900 flex items-center gap-2">
          <GradientIcon type={iconType} />
          {title}
        </h3>
        <span className={`px-2 py-1 text-xs font-medium rounded-full ${color}`}>
          {insights.length}
        </span>
      </div>
      
      <div className="h-64 overflow-y-auto space-y-3 pr-2">
        {insights.map((insight, index) => (
          <div key={index} className="border-l-4 border-blue-500 pl-3 py-2 bg-gray-50 rounded-r">
            <div className="flex items-start justify-between">
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-900 truncate" title={insight.query}>
                  {insight.query}
                </p>
                <p className="text-xs text-gray-600 mt-1">
                  {insight.description}
                </p>
                {insight.page && (
                  <p className="text-xs text-gray-500 mt-1 truncate flex items-center gap-1" title={insight.page}>
                    <GradientIcon type="page" size="w-3 h-3" />
                    <a 
                      href={insight.page} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:text-blue-800 hover:underline"
                    >
                      {insight.page}
                    </a>
                  </p>
                )}
                {insight.conflictingPages && insight.conflictingPages.length > 1 && (
                  <div className="mt-2">
                    <p className="text-xs text-red-600 font-medium mb-1 flex items-center gap-1">
                      <GradientIcon type="warning" size="w-3 h-3" />
                      Conflicting Pages:
                    </p>
                    <div className="space-y-1 max-h-20 overflow-y-auto">
                      {insight.conflictingPages.map((page, pageIndex) => (
                        <p key={pageIndex} className="text-xs text-gray-500 truncate" title={page}>
                          • <a 
                              href={page} 
                              target="_blank" 
                              rel="noopener noreferrer"
                              className="text-blue-600 hover:text-blue-800 hover:underline"
                            >
                              {page}
                            </a>
                        </p>
                      ))}
                    </div>
                  </div>
                )}
                <p className="text-xs text-blue-600 mt-1 font-medium flex items-center gap-1">
                  <GradientIcon type="lightbulb" size="w-3 h-3" />
                  {insight.action}
                </p>
              </div>
              <div className="flex flex-col items-end gap-1 ml-3 flex-shrink-0">
                {typeof onAddTodo === 'function' && (() => {
                  const todoKey = `Optimize: ${insight.query}-SEO Opportunities`;
                  const isAdded = addedTodos?.has(todoKey) || false;
                  const isAdding = addingTodos.has(todoKey);
                  
                  return (
                    <button
                      onClick={() => handleAddTodo(insight)}
                      disabled={isAdded || isAdding}
                      className={`text-xs px-2 py-1 rounded transition-colors ${
                        isAdded 
                          ? 'bg-gray-300 text-gray-500 cursor-not-allowed' 
                          : isAdding
                          ? 'bg-yellow-500 text-white cursor-wait'
                          : 'bg-green-600 hover:bg-green-700 text-white'
                      }`}
                      title={isAdded ? "Already added to your to-do list" : "Add this SEO task to your to-do list"}
                    >
                      {isAdding ? 'Adding...' : isAdded ? 'Added' : '+ To-Do'}
                    </button>
                  );
                })()}
                <button
                  onClick={() => {
                    // Set position range based on insight type
                    let positionRange = '';
                    if (insight.type === 'quick-win') positionRange = '1-10';
                    if (insight.type === 'striking-distance') positionRange = '11-20';
                    if (insight.type === 'ctr-anomaly') positionRange = '1-10';
                    onApplyFilter(insight.query, positionRange);
                  }}
                  className="text-xs bg-blue-100 text-blue-600 px-2 py-1 rounded hover:bg-blue-200 transition-colors"
                  title="Filter to this query"
                >
                  Filter
                </button>
                <a
                  href={`https://www.google.co.uk/search?q=${encodeURIComponent(insight.query)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs bg-green-100 text-green-600 px-2 py-1 rounded hover:bg-green-200 transition-colors"
                  title="Search Google UK"
                >
                  SERP
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const InsightsPanel: React.FC<InsightsPanelProps> = ({ insights, onApplyFilter, onDownloadCSV, onAddTodo, addedTodos }) => {
  if (insights.total === 0) {
    return (
      <div className="bg-gradient-to-r from-blue-50 to-green-50 rounded-lg border border-gray-200 p-6 mb-6">
        <div className="text-center">
          <div className="mb-2">
            <GradientIcon type="sparkles" size="w-8 h-8" />
          </div>
          <h2 className="text-xl font-bold text-gray-900 mt-2">SEO Analysis Complete</h2>
          <p className="text-gray-600 mt-1">No immediate optimization opportunities detected in your current data set.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-r from-blue-50 to-green-50 rounded-lg border border-gray-200 p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-xl font-bold text-gray-900 flex items-center gap-2">
            <GradientIcon type="target" size="w-6 h-6" />
            SEO Opportunities
          </h2>
          <p className="text-gray-600 text-sm mt-1">
            Found {insights.total} optimization opportunities based on your search performance data
          </p>
        </div>
        {onDownloadCSV && insights.total > 0 && (
          <button
            onClick={onDownloadCSV}
            className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md transition duration-200 flex items-center text-sm"
          >
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            Download CSV
          </button>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <InsightCard
          title="Quick Wins"
          iconType="quickWin"
          insights={insights.quickWins}
          color="bg-red-100 text-red-600"
          onApplyFilter={onApplyFilter}
          onAddTodo={onAddTodo}
          addedTodos={addedTodos}
        />
        
        <InsightCard
          title="Striking Distance"
          iconType="strikingDistance"
          insights={insights.strikingDistance}
          color="bg-orange-100 text-orange-600"
          onApplyFilter={onApplyFilter}
          onAddTodo={onAddTodo}
          addedTodos={addedTodos}
        />
        
        <InsightCard
          title="CTR Issues"
          iconType="ctrAnomaly"
          insights={insights.ctrAnomalies}
          color="bg-red-100 text-red-600"
          onApplyFilter={onApplyFilter}
          onAddTodo={onAddTodo}
          addedTodos={addedTodos}
        />
        
        <InsightCard
          title="Possible Featured Snippets"
          iconType="featuredSnippet"
          insights={insights.featuredSnippets}
          color="bg-purple-100 text-purple-600"
          onApplyFilter={onApplyFilter}
          onAddTodo={onAddTodo}
          addedTodos={addedTodos}
        />
        
        <InsightCard
          title="Keyword Conflicts"
          iconType="warning"
          insights={insights.cannibalization}
          color="bg-yellow-100 text-yellow-600"
          onApplyFilter={onApplyFilter}
          onAddTodo={onAddTodo}
          addedTodos={addedTodos}
        />
        
        <InsightCard
          title="Long-tail"
          iconType="longTail"
          insights={insights.longTail}
          color="bg-green-100 text-green-600"
          onApplyFilter={onApplyFilter}
          onAddTodo={onAddTodo}
          addedTodos={addedTodos}
        />
        
        <InsightCard
          title="Local SEO"
          iconType="localIntent"
          insights={insights.localIntent}
          color="bg-blue-100 text-blue-600"
          onApplyFilter={onApplyFilter}
          onAddTodo={onAddTodo}
          addedTodos={addedTodos}
        />
      </div>
    </div>
  );
};

export default InsightsPanel;